import { MatDialogConfig } from '@angular/material/dialog';

export const FullScreenDialogConfig: MatDialogConfig<never> = {
  width: '100vw',
  height: '100vh',
  maxWidth: '100vw',
  panelClass: 'full-screen-dialog',
  enterAnimationDuration: 200,
  exitAnimationDuration: 200,
};
